import * as React from 'react'

function SvgPhoneContained(props, svgRef) {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M16.858 12.444l-3.646-1.563a.781.781 0 00-.912.225l-1.614 1.973A12.066 12.066 0 014.918 7.31L6.89 5.696a.78.78 0 00.224-.911L5.553 1.139a.787.787 0 00-.896-.453l-3.385.781a.781.781 0 00-.605.762c0 8.35 6.767 15.104 15.104 15.104a.781.781 0 00.762-.605l.78-3.386a.79.79 0 00-.455-.898z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgPhoneContained)
export default ForwardRef
